import * as React from 'react'

import type { LocationDTO } from '@sales-center/common'
import { ENTITY_TYPES } from '@sales-center/common'
import type { ILeadOppProduct } from '@user/store/leadOppProducts'

import { LocationSelect } from './LocationSelect'
import { useSchedulingWizard } from '../wizardContext'
import { ServiceCheckboxes } from './ServiceCheckboxes'
import { ScheduledAppointments } from './ScheduledAppointments'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { OppCloseOnScheduleSection } from './CloseOnCommit'
import { LeadAutoCloseSection } from './LeadAutoClose'

type ContentProps = {
  services: ILeadOppProduct[]
  serviceLocations: LocationDTO[]
}

export function Content(props: ContentProps) {
  const { services, serviceLocations } = props

  const [{ mode, entityId, entityType }] = useSchedulingWizard()

  const helperText =
    mode === 'free'
      ? 'free non-billable estimate'
      : mode === 'paid'
        ? 'billable estimate'
        : 'service'

  const showCloseRadioBtn =
    mode === 'service' && entityType === ENTITY_TYPES.Opportunity

  const showLeadAutoClose =
    mode === 'service' && entityType === ENTITY_TYPES.Lead

  return (
    <Stack px={2}>
      <Typography variant="body1">
        Schedule a {helperText} for this Service Location
      </Typography>

      <Box
        sx={{ display: 'flex', flexDirection: 'column', gap: 1.6, mt: 2.56 }}
      >
        <Typography variant="subtitle3">Select Service Location</Typography>
        <LocationSelect serviceLocations={serviceLocations} />
      </Box>

      <ScheduledAppointments entityId={entityId} entityType={entityType} />

      <ServiceCheckboxes services={services} />
      {showLeadAutoClose && <LeadAutoCloseSection entityId={entityId} />}

      {showCloseRadioBtn && <OppCloseOnScheduleSection />}
    </Stack>
  )
}
